import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserManager } from 'oidc-client';
import { getAuthKeys } from '../../api/configurationAPI';
import { AuthKeys } from '../../dto/authorization/AuthKeys';
import userManager from '../../oidc/UserManager';

interface AuthState {
  value: AuthKeys[] | null;
  userManager: UserManager;
  isLoading: boolean;
  error: string | null;
  updatedWithKeys: boolean;
}

export const initialState: AuthState = {
  value: null,
  userManager: userManager(),
  isLoading: false,
  error: null,
  updatedWithKeys: false,
};

function startLoading(state: AuthState) {
  state.isLoading = true;
}

export const fetchAuthKeys = createAsyncThunk('fetchAuthKeys', async () => {
  const response = await getAuthKeys();
  return response;
});

export const authorizationSlice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    setUserManager(state, action: PayloadAction<UserManager>) {
      state.userManager = action.payload;
      state.updatedWithKeys = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAuthKeys.pending, startLoading);
    builder.addCase(fetchAuthKeys.fulfilled, (state, { payload }) => {
      state.value = payload;
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(fetchAuthKeys.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message || 'Fetching auth keys failed';
    });
  },
});

export const { setUserManager } = authorizationSlice.actions;

export default authorizationSlice.reducer;
